export const CompanyRank = () => import("./CompanyRank.vue");
export const Show = () => import("./Show.vue");
export const List = () => import("./List.vue");
export const CompanyList = () => import("./CompanyList.vue");
export const DateCompany = () => import("./DateCompany.vue");
